export default {
    listagem: {
        titulo_pagina: 'Lista de Atributos',
        novo: 'Crear Nuevo Atributo',
        table: {
            empty: 'No se encontraron atributos',
            nome: 'Nombre',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Crear Nuevo Atributo',
            editar: 'Editar Atributo'
        },
        fields: {
            nome: {
                label: 'Nombre',
                description: 'Nombre del Atributo'
            },
            status: {
                label: 'Estado',
                description: 'Atributo estado activo o inactivo'
            },
            botao_salvar : 'Guardar Atributo'
        },
        create: {
            success: '¡Atributo creado con éxito!',
            error: '¡Error al crear el atributo!'
        },
        update: {
            success: '¡Atributo editado con éxito!',
            error: '¡Error al editar el atributo!'
        }
    }
}
